import { render, staticRenderFns } from "./MaillingForm.vue?vue&type=template&id=517cbdde&scoped=true&lang=pug&"
import script from "./MaillingForm.vue?vue&type=script&lang=js&"
export * from "./MaillingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517cbdde",
  null
  
)

export default component.exports